import React from "react";
import { RefreshCw } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("UI crash tertangkap ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[#FAF9F5] px-6 text-center" data-testid="error-boundary">
          <div className="w-16 h-16 rounded-2xl bg-rose-100 text-rose-600 flex items-center justify-center">
            <RefreshCw className="w-8 h-8" />
          </div>
          <h1 className="font-display text-xl font-bold text-slate-800">Ups, ada sedikit gangguan</h1>
          <p className="text-slate-500 max-w-sm">Halaman gagal dimuat. Silakan muat ulang, datamu tetap aman.</p>
          <button
            onClick={() => window.location.reload()}
            className="h-11 px-6 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-semibold transition-colors"
            data-testid="error-reload-btn"
          >
            Muat Ulang Halaman
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
